import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight, Loader2, Workflow } from 'lucide-react';
import ChatBubble from './ChatBubble';

const getStepLabel = step => {
  if (!step) return 'Agent steps';
  return step?.tool_name === 'thinking...' ? 'Thinking' : step?.tool_name;
};

const IntermediateStepsPanel = ({ steps = [], isLoading }) => {
  const [open, setOpen] = useState(false);

  if (!steps?.length) return null;

  const stepCount = steps.length;
  const lastStep = steps[stepCount - 1];
  const activeLabel = getStepLabel(lastStep);

  const summaryText = isLoading
    ? activeLabel
    : `${stepCount} step${stepCount !== 1 ? 's' : ''}`;

  return (
    <div className="rounded-[22px] bg-shell-card border border-shell-border shadow-soft mb-5 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="flex w-full items-center gap-2.5 px-3 py-2.5 text-left group hover:bg-paper transition-colors">
        <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-space/10">
          <Workflow className="size-4 text-space" />
        </div>
        <span className="text-[15px] leading-5 font-medium text-ink group-hover:text-ink transition-colors">
          Agent steps
        </span>
        <span className="text-[13px] leading-5 text-mute truncate">{summaryText}</span>
        {isLoading && <Loader2 className="size-4 shrink-0 animate-spin text-space" />}
        <ChevronRight
          className={`ml-auto size-5 shrink-0 text-mute transition-transform duration-200 ${open ? 'rotate-90' : ''}`}
        />
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden">
            <div className="px-3 pb-2.5 pt-1 border-t border-shell-border">
              {steps.map((chunk, index) => (
                <ChatBubble
                  key={index}
                  index={index}
                  message={chunk}
                  allMessages={steps}
                  isLoading={isLoading}
                />
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default IntermediateStepsPanel;
